import { render } from "./AcademicWeekdayHigh.vue?vue&type=template&id=551529b8&scoped=true"
import script from "./AcademicWeekdayHigh.vue?vue&type=script&lang=js"
export * from "./AcademicWeekdayHigh.vue?vue&type=script&lang=js"

import "./AcademicWeekdayHigh.vue?vue&type=style&index=0&id=551529b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551529b8"]])

export default __exports__